<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item>常見問題</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          常見問題 <i class="far fa-question-circle"></i> <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        </div>
        <section>
          <el-collapse v-model="activeNames">
            <el-collapse-item 
              v-for="(faq, idx) in faq_list"
              :name="idx"
              :key="idx"
            >
              <template slot="title">
                <h5 class="c-gray-222">{{`Q${(page_num-1)*page_limit+idx+1}&nbsp;&nbsp;${faq.question}`}}</h5>
              </template>
              <div class="c-gray-666 des">{{faq.answer}}</div>
            </el-collapse-item>
          </el-collapse>
          <el-pagination
            class="align-center" 
            @size-change="handle_page_size_change"
            @current-change="handle_current_page_change"
            :current-page="page_num" 
            :page-sizes="[10,20,50]"
            :page-size="page_limit"
            layout="total, prev, pager, next, sizes, jumper " 
            :total="faq_total" 
            background
          >
          </el-pagination>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  import api from '@/api/frontstage'
  export default {
    name: 'faq',
    components: {
      HeaderSlide,
    },
    async created () {
      await this.update_faq_list()
    },
    data() {
      return {
        activeNames: ['1'],
        faq_list: [],
        page_num: 1,
        page_limit: 10,
        faq_total: 0
      }
    },
    methods: {
      async update_faq_list() {
        let res = await api.get_FAQ_list(this.page_limit, this.page_num)
        if (res.success) {
          console.log('[前臺] FAQ list: ', res)
          for (let i = 0; i < res['payload']['payload']['search_result'].length; i += 1) {
            res['payload']['payload']['search_result'][i]['q_index'] = i+1
          }
          this.$set(this, 'faq_list', res['payload']['payload']['search_result'])
          this.faq_total = res['payload']['payload']['search_count']
        }
        else {
          this.$set(this, 'faq_list', [])
          this.faq_total = 0
          this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得列表', res.message)
        }
      },
      handle_page_size_change (size) {
        this.page_limit = size
        this.page_num = 1
        this.update_faq_list()
      },
      handle_current_page_change (page) {
        this.page_num = page
        this.update_faq_list()
      },
    }
  }
</script>

<style lang="scss" scoped>
  .des {
    white-space: pre-line;
  }
  .accesskey-content{
    color: white;
  }
</style>
